import { render, staticRenderFns } from "./persons.vue?vue&type=template&id=a9d3eb6a&scoped=true"
import script from "./persons.vue?vue&type=script&lang=js"
export * from "./persons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d3eb6a",
  null
  
)

export default component.exports